import { getMeter } from './index';

const METRIC_DEFS = {
  CLS: { name: 'web_vitals.cls', unit: '1', description: 'Cumulative Layout Shift' },
  FID: { name: 'web_vitals.fid', unit: 'ms', description: 'First Input Delay' },
  FCP: { name: 'web_vitals.fcp', unit: 'ms', description: 'First Contentful Paint' },
  LCP: { name: 'web_vitals.lcp', unit: 'ms', description: 'Largest Contentful Paint' },
  TTFB: { name: 'web_vitals.ttfb', unit: 'ms', description: 'Time to First Byte' },
};

const RATING_THRESHOLDS = {
  CLS: { good: 0.1, poor: 0.25 },
  FID: { good: 100, poor: 300 },
  FCP: { good: 1800, poor: 3000 },
  LCP: { good: 2500, poor: 4000 },
  TTFB: { good: 800, poor: 1800 },
};

const rateValue = (name, value) => {
  const t = RATING_THRESHOLDS[name];
  if (!t) return 'unknown';
  if (value <= t.good) return 'good';
  if (value <= t.poor) return 'needs_improvement';
  return 'poor';
};

const histogramCache = new Map();
let enabled = false;

const getHistogram = (name) => {
  if (!histogramCache.has(name)) {
    const def = METRIC_DEFS[name];
    if (!def) return null;
    const meter = getMeter('web-vitals');
    histogramCache.set(
      name,
      meter.createHistogram(def.name, {
        unit: def.unit,
        description: def.description,
      }),
    );
  }
  return histogramCache.get(name);
};

export function recordWebVital(metric) {
  if (!enabled || !metric?.name) return;
  const histogram = getHistogram(metric.name);
  if (!histogram) return;

  histogram.record(metric.value, {
    rating: rateValue(metric.name, metric.value),
    navigation_type: metric.navigationType || 'unknown',
    route: typeof window !== 'undefined' ? window.location.pathname : 'unknown',
  });
}

export function initWebVitals() {
  if (enabled || typeof window === 'undefined') return;
  enabled = true;

  import('web-vitals')
    .then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(recordWebVital);
      getFID(recordWebVital);
      getFCP(recordWebVital);
      getLCP(recordWebVital);
      getTTFB(recordWebVital);
    })
    .catch(() => {
      enabled = false;
    });
}
